import ErpDashboard from '../shared/ErpDashboard';

function AdminDashboardHome({ user }) {
  return <ErpDashboard user={user} mode="admin" />;
}

export default AdminDashboardHome;
